import PropTypes from 'prop-types'
import { useContext, useEffect, useRef, useState } from 'react'

// Internal components
import Caption from '../Caption/Caption'
import CookiePlaceholder from '../CookiePlaceholder/CookiePlaceholder'
import LazyImage from '../LazyImage/LazyImage'
import PlaySymbol from '../PlaySymbol/PlaySymbol'

// Context
import { NavigationContext } from '../../context/NavigationContext'

// Utils
import { getIdFromVideoUrl } from '../../utils/video/getIdFromVideoUrl'
import { appendScriptPromise } from '../../utils/dom/appendScriptPromise'

const YoutubeEmbed = (props) => {
  const { url, image, caption, id } = props

  const [showThumb, setShowThumb] = useState(true)
  const navigationContext = useContext(NavigationContext)

  const embedWrapperRef = useRef()

  const youtubeId = url && getIdFromVideoUrl(url)
  const youtubeScriptUrl = 'https://www.youtube.com/iframe_api'
  const ytScriptId = 'ytScript'

  const playerEvents = {
    onReady: (event) => event.target.playVideo()
  }
  const playerSettings = {
    videoId: youtubeId,
    events: playerEvents,
    fs: 0,
    playsinline: 1,
    modestbranding: 1,
    autoplay: 1
  }

  // eslint-disable-next-line no-unused-vars, no-undef
  let player
  const setupEmbed = () => {
    if (!window.YT) appendScriptPromise(youtubeScriptUrl, ytScriptId)
  }
  const startVideo = () => {
    // eslint-disable-next-line no-unused-vars, no-undef
    player = new YT.Player(`player-${id}`, playerSettings)
  }
  const playSymbolHandler = () => {
    setShowThumb(false)
    startVideo()
  }

  useEffect(() => {
    if (navigationContext.hasConsent('youtube')) setupEmbed()
  }, [navigationContext.cookiesConsent])

  return (
    <div className="YoutubeEmbed">
      <div className="YoutubeEmbed-wrapper" ref={embedWrapperRef}>
        <div className="YoutubeEmbed-target">
          <div className={`YoutubeEmbed-thumbnail ${showThumb ? '' : 'is-hidden'}`} onClick={playSymbolHandler}>
            <PlaySymbol modifiers={[showThumb ? '' : 'is-hidden']} />
            {image?.[0] && (
              <LazyImage
                image={image[0].image}
                alt={image[0].alt ? image[0].alt : ''}
                sizes="(min-width: 1580px) 360px, (min-width: 1024px) 25vw, (min-width: 760px) 33vw, 100vw"
                modifiers={['LazyImage--youtubeEmbed']}
              />
            )}
          </div>
          <div className="YoutubeEmbed-player" id={`player-${id}`}></div>
        </div>
        <CookiePlaceholder modifiers={['CookiePlaceholder--youtubeEmbed']} placeholderWrapperRef={embedWrapperRef} />
        {caption && <Caption iconId="icon-video" html={caption} />}
      </div>
    </div>
  )
}

YoutubeEmbed.propTypes = {
  id: PropTypes.string.isRequired,
  url: PropTypes.string.isRequired,
  image: PropTypes.array.isRequired,
  caption: PropTypes.string
}

export default YoutubeEmbed
